import React, {useEffect, useState} from 'react';
import {getDatabase, limitToLast, onValue, orderByChild, query, ref} from "firebase/database";
import app from "../../../firebaseConfig/firebaseConfig";
import {CardContent} from "@mui/material";
import {useUser} from "../../../managers/userManager/userManager";
import OrderCard from "../components/OrderCard";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import {Trans} from "react-i18next";

const db = getDatabase(app);

function MyOrders(props) {
    const user = useUser();
    const [orders, setOrders] = useState();
    const [limit, setLimit] = useState(10);

    useEffect(() => {
        if (!db || !user.uid) {
            return;
        }

        const orderRef = ref(db, `/orders/${user.uid}`);
        onValue(query(orderRef, orderByChild('nr'), limitToLast(limit)), (snapshot) => {
            setOrders(snapshot.val());
        });
    }, [user, limit]);

    return (orders &&
        <div className="myorders">{Object.keys(orders).reverse().map(key => <CardContent key={key}>
                <OrderCard order={orders[key]}/>
            </CardContent>
        )}
            {(limit > Object.keys(orders).length) ? '' :
                <Box sx={{display: 'flex', justifyContent: 'center'}}><Button onClick={() => {
                    setLimit(limit + 10);
                }}><Trans i18nKey={'buttons.viewMore'}/></Button></Box>}
        </div>
    );
}

export default MyOrders;
